/**
 * VETRO collection cards: deterministic swatch -> image swap.
 * Uses per-swatch media id + image URL attributes from variant-swatches.liquid.
 */
(function () {
  'use strict';

  /** @param {Element} card @param {string} slideId */
  function findSlideById(card, slideId) {
    if (!slideId) return null;
    return card.querySelector('slideshow-slide[slide-id="' + String(slideId) + '"]');
  }

  /** @param {Element} card */
  function getVisibleSlide(card) {
    return (
      card.querySelector('slideshow-slide[aria-hidden="false"]') ||
      card.querySelector('slideshow-slide:not([hidden])') ||
      card.querySelector('slideshow-slide')
    );
  }

  /** @param {Element} slide @param {string} src */
  function setSlideImageSrc(slide, src) {
    if (!src) return;
    var img = slide.querySelector('img');
    if (!(img instanceof HTMLImageElement)) return;
    img.src = src;
    img.removeAttribute('srcset');
  }

  /** @param {Element} card @param {string} slideId */
  function selectSlide(card, slideId) {
    if (!slideId) return;
    var slideshow = /** @type {HTMLElement & { select?: Function } | null} */ (card.querySelector('slideshow-component'));
    var targetSlide = findSlideById(card, slideId);
    if (!targetSlide) return;

    var slides = card.querySelectorAll('slideshow-slide[slide-id]');
    slides.forEach(/** @param {Element} slide */ function (slide) {
      var slideEl = /** @type {HTMLElement} */ (slide);
      var match = String(slide.getAttribute('slide-id')) === String(slideId);
      slideEl.hidden = !match;
      slideEl.setAttribute('aria-hidden', match ? 'false' : 'true');
      if (match) slideEl.setAttribute('reveal', '');
      else slideEl.removeAttribute('reveal');
    });

    if (slideshow && typeof slideshow.select === 'function') {
      try {
        var p = slideshow.select({ id: String(slideId) }, undefined, { animate: false });
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (err) {
        /* no-op */
      }
    }
  }

  /** @param {Event} e */
  function onSwatchChange(e) {
    if (!(e.target instanceof HTMLInputElement)) return;
    if (e.target.type !== 'radio') return;
    if (!e.target.name || e.target.name.indexOf('-swatch') === -1) return;

    var card = e.target.closest('product-card');
    if (!card) return;

    var slideId = e.target.dataset.optionMediaId || '';
    var imageSrc = e.target.dataset.optionImageSrc || '';

    var targetSlide = slideId ? findSlideById(card, slideId) : null;

    if (imageSrc && targetSlide) {
      setSlideImageSrc(targetSlide, imageSrc);
    } else if (imageSrc) {
      var visibleSlide = getVisibleSlide(card);
      if (visibleSlide) setSlideImageSrc(visibleSlide, imageSrc);
    }

    if (slideId) selectSlide(card, slideId);
  }

  function init() {
    document.addEventListener('change', onSwatchChange, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
